import { ref } from 'yup'
import { getQuestionUuidFromPath } from './getQuestionUuidFromValidationPath'

/**
 * @param schema
 * @returns {IntakeFieldType | undefined}
 */
export const getTestedQuestion = (schema) => schema.resolve(ref(`$${getQuestionUuidFromPath(schema.path)}`))

export default getTestedQuestion
